import type { ValidationError } from 'yup'

/**
 * @memberof ValidationMessage
 * */
export const getErrorsForFields = (errors: ValidationError[], fieldNames: string | string[]) => {
    if (typeof fieldNames === 'string') {
        return errors.filter((error) => error.path?.toLowerCase() === fieldNames.toLowerCase())
    }
    return errors.filter((error) => fieldNames.some((name) => name.toLowerCase() === error.path?.toLowerCase()))
}
